//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            vetList: [],
            view: 340,
            page: 1
        }
    },
    mounted() {
        this.initSwiper()
        // 处理ios与Android屏幕问题 35为后续露出宽度
        this.view = window.innerWidth>650?650-35:window.innerWidth-35
    },
    methods: {
        //获取兽医推荐
        initSwiper() {
            this.$http.get(`${this.$store.state.origin}/api/vet/getProfile?page=${this.page}`)
                .then(res => {
                    //处理数据中分隔符不统一
                    this.vetList = res.body.result.map(res => {
                        res.skilled = res.skilled.replace(/，/g,'、')
                        res.skilled = res.skilled.split('、')
                        // res.title = res.title.slice(0,6)
                        return {
                            ...res
                        }
                    })
            
                })
        },
        //兽医详情
        goDetail(id) {
            window.location.assign(`//m.wecarepet.com/serverNumber/vetDetail?vetId=${id}`)
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/vetRecommend.vue